import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ServerService} from "./ServerService";

@Injectable({
  providedIn: 'root'
})
export class EmpresaService extends  ServerService {
  constructor(public http: HttpClient) {
      super(http)
  }

  atualizeEnviarLinksBotao(empresa: any) {
    return this.http.put('/empresas/atualizeEnviarLinksBotao', {
      id: empresa.id,
      enviarLinksBotao: empresa.enviarLinksBotao
    })
      .toPromise();
  }

  atualizeBotAtivo(empresa: any) {
    return this.http.put('/empresas/atualizeBotAtivo', {
      id: empresa.id,
      dominio: empresa.dominio,
      cardapio: empresa.cardapio
    })
      .toPromise();
  }

  salveNovaLocalizacao(empresa: any, latitude: string, longitude: string) {
    return this.http.put('/empresas/atualizeLocalizacao', {
      id: empresa.id,
      latitude: latitude,
      longitude:  longitude
    })
      .toPromise();
  }

  altereAceitarPedido(aceitarAutomatico: boolean){
    return this.facaPut('/empresas/pedidos/aceitar/auto', {aceitarAutomatico: aceitarAutomatico})
  }

  salveIntegracaoIfood(empresa: any, integracao: any){
    return this.facaPost('/ifood/' + empresa.id + '/integracao/ifood', integracao);
  }

  removaIntegracaoIfood(integracaoIfood: any){
    return this.facaPost('/ifood/integracao/ifood/remova/' + integracaoIfood.id, {});
  }

  desativeIntegracaoIfood(integracaoIfood: any){
    return this.facaPost('/ifood/integracao/ifood/desative/' + integracaoIfood.id, {});
  }

  ativeIntegracaoIfood(integracaoIfood: any){
    return this.facaPost('/ifood/integracao/ifood/ative/' + integracaoIfood.id, {});
  }


  atualizeIntegracaoIfood(integracao: any){
    return this.facaPost('/ifood/integracao/atualize', integracao);
  }

  autorizeNovaLoja(dados: any){
    return this.facaPost('/ifood/autorizacao/confirme', dados);
  }
  gereLinkAtivacaoIfood(){
    return this.facaPost('/ifood/autorizacao/gere', {});
  }

  sincronizeFormasPagamentoIfood(){
    return this.facaPost('/ifood/formaspagamento/sincronize', {});
  }

  obtenhaAtivacaoPendente(empresa: any){
    return this.http.get('/ifood/autorizacao/' + empresa.id , { })
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  sincronizeFormasPagamentoKeeta(){
    return this.facaPost('/keeta/formaspagamento/sincronize', {});
  }

  obtenhaLojasAtivar(authId: any){
    return this.http.get(`/keeta/autorizacao/${authId}/lojas` , { })
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  obtenhaAppInfo( ){
    return this.http.get(`/keeta/me/appinfo` , { })
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  gereLinkAtivacaoKeeta(){
    return this.facaPost('/keeta/autorizacao/gere', {});
  }

  confirmeIntegracaoLojaKeeta(dados: any){
    return this.facaPost('/keeta/autorizacao/confirme' , dados);
  }

  removaIntegracaoKeeta(integracaoIfood: any){
    return this.facaPost('/keeta/integracao/remova/' + integracaoIfood.id, {});
  }

  abrirLojaKeeta(){
    return this.facaPost('/keeta/loja/abrir', {});
  }

  fecharLojaKeeta(){
    return this.facaPost('/keeta/loja/fechar', {});
  }

  gereLinkAtivacao99Food(){
    return this.facaPost('/99food/autorizacao/gere', {});
  }

  confirmeIntegracaoLoja99Food(dados: any){
    return this.facaPost('/99food/autorizacao/confirme', dados);
  }

  removaIntegracao99Food(integracao: any){
    return this.facaPost('/99food/integracao/remova/' + integracao.id, {});
  }

  abrirLoja99Food(loja: any){
    return this.facaPost('/99food/loja/abrir', loja);
  }

  fecharLoja99Food(loja: any){
    return this.facaPost('/99food/loja/fechar', loja);
  }

  obtenhaLojasAtivar99Food(authId: any){
    return this.http.get(`/99food/autorizacao/${authId}/lojas`, { })
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  sincronizeFormasPagamento99Food(){
    return this.facaPost('/99food/formaspagamento/sincronize', {});
  }

  altere99FoodMetodoConfirmacao(dados: any){
    return this.facaPost('/99food/loja/confirmacao/metodo', dados);
  }

  altere99FoodStatusAutomatico(dados: any){
    return this.facaPost('/99food/loja/status/automatico', dados);
  }

  altere99FoodAceitarCancelamento(integracao: any){
    return this.facaPost('/99food/loja/aceitarCancelamento', integracao);
  }

  altere99FoodAceitarReembolso(integracao: any){
    return this.facaPost('/99food/loja/aceitarReembolso', integracao);
  }


  listeFormasAtivasMesa(){
    return this.http.get('/integracaoerp/formaspagamento/mesas/ativas' , { })
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  listeBanco() {
    return this.http.get('/api/bancos', { })
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  registreEmpresaTuna(empresaTuna: any) {
    return this.facaPost('/tunapay/empresa/registre', empresaTuna);
  }

  verifiqueRetornoRegistroTuna() {
    return this.facaPost('/tunapay/me/merchant/sincronize', {});
  }

  obntehaMerchantTuna() {
    return this.obtenha('/tunapay/me/merchant/dto', {});
  }

  obntehaPadraoMCIPay() {
    return this.obtenha('/tunapay/meucardapiopay/padrao', {});
  }
}
